const webIndex = () => import ('@/web/index');
const about = () => import ('@/web/about');
export default [
  {
    path: '/web',
    component: webIndex,
    meta: {public: true},
  },
  {
    path: '/web/about',
    meta: {public: true},
    component: about,
  },
];



// WEBPACK FOOTER //
// ./src/router/web.js